import permissions from 'common/constant/user-permissions-obj'

export default {
  authed: false,
  loggingIn: false,
  loginMessage: '',
  userData: {
    permissions
  }
}
